<template>
  <div>
    <div class="text-h6 text-uppercase text-weight-bold q-mb-md">
      {{ $t('payment.locations') }}
    </div>
    <div class="column q-col-gutter-lg">
      <div
        v-for="location in allLocations"
        :key="location.id"
        class="col-xs-12 col-sm-6 col-md-3"
      >
        <div
          class="location cursor-pointer text-body1
          rounded-borders q-py-lg q-px-md full-height"
          :class="{
            selected: selected === location.id
          }"
        >
          <q-radio
            v-model="selected"
            color="secondary"
            :val="location.id"
            :disable="location.closed === 1"
            @input="selectLocation(location)"
            @click="selectLocation(location)"
          >
            <div class="q-ml-md">
              <div class="text-weight-regular text-h6">
                {{ translateTitle(location) }}
              </div>
              <div class="text-weight-regular text-body2">
                {{ translateShortDescription(location) }}
              </div>
            </div>
          </q-radio>
          <div
              v-if="location.closed && location.closedReason"
              class="text-white text-center bg-secondary q-mt-md"
          >
            <div class="q-py-sm text-weight-medium">
              {{ location.closedReason }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import language from 'quasar-pilot-core/src/mixins/util/language';
import LocationModel from 'quasar-pilot-core/src/lib/models/location';

export default {
  name: 'OrderLocations',
  mixins: [language],
  props: {
    catering: {
      type: Boolean,
      default: false,
    },
    categoryId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      selected: null,
      allLocations: [],
    };
  },

  computed: {
    ...mapState('order', ['location']),
    ...mapState('location', ['all', 'current']),
  },

  created() {
    this.allLocations = [];

    if (this.catering) {
      this.filterCateringLocations();
    }
    else {
      this.filterNormalLocations();
    }

    this.filterQrLocations();

    if (this.location) {
      this.selected = this.location.id;
    }
  },

  methods: {
    ...mapMutations('location', ['updateCurrentLocation']),
    ...mapMutations('order', { updateOrderLocation: 'updateLocation' }),

    selectLocation(location) {
      const newLoc = new LocationModel(location);
      if (!this.catering) {
        this.updateCurrentLocation(newLoc);
      }
      this.updateOrderLocation(newLoc);
      this.selected = newLoc.id;
    },

    filterQrLocations() {
      this.allLocations = this.allLocations.filter((location) => (location.codename.indexOf('qr-') === -1));
    },

    filterNormalLocations() {
      this.all.forEach((location) => {
          location.openingHours.forEach((openingHour) => {
            openingHour.days.forEach((day) => {
              // 00:00 - 23:59
              if ((day.start !== 0 && day.end !== 1439) && !this.allLocations.includes(location)) {
                this.allLocations.push(location);
              }
            });
          });
      });
    },

    filterCateringLocations() {
      let availableLocations = this.all;
      if (this.categoryId) {
        availableLocations = availableLocations.filter((l) => l.categoryId === this.categoryId);
      }
      availableLocations.forEach((location) => {
        location.openingHours.forEach((openingHour) => {
          openingHour.days.forEach((day) => {
            // 00:00 - 23:59
            if ((day.start === 0 || day.end === 1439) && !this.allLocations.includes(location)) {
              this.allLocations.push(location);
            }
          });
        });
      });

      if (this.allLocations.length === 1) {
        this.selectLocation(this.allLocations[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.location {
  border: 1px solid $table-border-color;
}

.selected {
  border-color: $secondary;
}
</style>
